import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Box, Select, TextArea } from '@usealloy/component-library';

import { defaultReason, REASON_OPTIONS } from './constants';

interface ReasonForAccessInputProps {
  setCustomInputs(customInput: string): void;
}

const ReasonForAccessInput: React.FC<ReasonForAccessInputProps> = ({ setCustomInputs }) => {
  const [selectedReason, setSelectedReason] = useState(defaultReason);
  const [otherText, setOtherText] = useState('');

  const otherSelected = useMemo(() => (
    selectedReason === 'Other'
  ), [selectedReason]);

  const formValue = useMemo(() => (
    otherSelected ? `Other - ${otherText}` : selectedReason
  ), [selectedReason, otherText]);

  useEffect(() => {
    setCustomInputs(formValue);
  }, [formValue]);

  return (
    <Box direction="column" gap={4}>
      <Select
        label="Reason for Access"
        placeholder="Select a reason for access"
        options={REASON_OPTIONS}
        onChange={event => {
          setSelectedReason(event.target.value);
          setCustomInputs(event.target.value);
        }}
      />
      {otherSelected && (
        <TextArea
          placeholder="Enter your reason for access"
          value={otherText}
          onChange={event => { setOtherText(event.target.value); }}
        />
      )}
    </Box>
  );
};

export default ReasonForAccessInput;
